import type { HealthBarBand } from '../api/health-bar'

// Vivid per-band "leave rhythm" palette, matching the redesign prototype.
// Shared by the wellbeing card (ring) and the home forfeiture banner so the
// banner themes to the same band colour as the card above it.

export interface RhythmStyle {
  ring: string      // ring stroke + icon + label colour
  fill: string      // soft tint (card ring fill / banner background)
  chipBg: string    // slightly stronger tint (banner border)
  chipText: string  // dark on-tint text (banner text + solid button)
  icon: string      // glyph in the ring centre
  iconSize: number
  label: string     // Steady | Heads up | Off rhythm
}

export const RHYTHM_STYLE: Record<HealthBarBand, RhythmStyle> = {
  low: {
    ring: '#22c55e', fill: '#f0fdf4', chipBg: '#dcfce7', chipText: '#166534',
    icon: '✓', iconSize: 30, label: 'Steady lah',
  },
  medium: {
    ring: '#f59e0b', fill: '#fffbeb', chipBg: '#fef9c3', chipText: '#92400e',
    icon: '⚠️', iconSize: 30, label: 'Heads up',
  },
  high: {
    ring: '#ef4444', fill: '#fef2f2', chipBg: '#fee2e2', chipText: '#991b1b',
    icon: '!', iconSize: 26, label: 'Off rhythm',
  },
}
